@import 'src/global/media_queries'
  
:host 
  display: block
  width: 100%
  padding: 2rem 0

  @include media(">=tablet")
    padding-top: 2rem
    padding-bottom: 2rem
    padding-left: 1.5rem !important
    padding-right: 1.5rem !important

.container-wrapper
  width: 100%
  margin: 0 auto

  & > *
    padding: 0.5rem 0

  ::slotted(*)
    text-align: center
    margin-bottom: 0.5rem !important

  ::slotted(h1),
  ::slotted(h2),
  ::slotted(h3)
    margin-top: 2.5rem !important

  ::slotted(*:last-child)
    margin-bottom: 0 !important

  ::slotted([slot=heading])
    line-height: 1 !important
    margin-bottom: 0 !important

  ::slotted(h1[slot=heading]),
  ::slotted(h2[slot=heading]),
  ::slotted(h3[slot=heading])
    margin-top: unset !important

  ::slotted(afs-link)
    color: var(--afs-link-color) !important


